import { Icon, Table, Text } from '@factorialco/deprecated-design-system'
import type moment from 'moment'

import { observer } from 'mobx-react'

import UserAvatar from 'modules/core/components/UserAvatar'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { employeeUser } from 'modules/core/store/collections/users'

import type Employee from 'modules/employees/store/models/Employee'

interface Props {
  employee: Employee
  effectiveAt: moment.Moment | undefined
}

const Item = ({ employee, effectiveAt }: Props) => {
  const { navigation } = useNavigation()

  const to = navigation.employees.id.fullPath({ id: employee.id })

  return (
    <Table.Row.Router to={to}>
      <Table.Cell colSpan={1}>
        <UserAvatar size="s40" user={employeeUser(employee)} />
      </Table.Cell>
      <Table.Cell colSpan={5}>
        <Text.Normal weight="medium">{employeeUser(employee).fullName()}</Text.Normal>
      </Table.Cell>
      <Table.Cell colSpan={5}>
        <Text.Normal>{effectiveAt?.format('ll')}</Text.Normal>
      </Table.Cell>
      <Table.Cell colSpan={1}>
        <Icon.Medium icon="arrow-right" />
      </Table.Cell>
    </Table.Row.Router>
  )
}

export default observer(Item)
